import { render } from "./table-row.vue?vue&type=template&id=37aee6ae"
import script from "./table-row.vue?vue&type=script&lang=js"
export * from "./table-row.vue?vue&type=script&lang=js"

import "./table-row.vue?vue&type=style&index=0&id=37aee6ae&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__